const cache = new Map<string, { at: number; promise: Promise<unknown> }>()
const TTL_MS = 30_000

export function cachedPreviewFetch<T>(key: string, fetcher: () => Promise<T>): Promise<T> {
  const hit = cache.get(key)
  if (hit && Date.now() - hit.at < TTL_MS) return hit.promise as Promise<T>
  const promise = fetcher()
  cache.set(key, { at: Date.now(), promise })
  return promise
}
